import React from "react";

const AppointmentsIcon = () => {
  return (
    <svg
      width="32"
      height="30"
      viewBox="0 0 32 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.74283 7.81257H28.8275M10.3139 1.14665V7.62592M20.2564 1.14665V7.02599M29.5703 10.3323V18.3314C29.5703 18.6247 29.5703 18.918 29.5417 19.198C28.9419 18.5079 28.1839 17.9522 27.3236 17.5715C26.4634 17.1908 25.5226 16.9949 24.5705 16.9982C23.0563 16.9982 21.6563 17.4915 20.5564 18.3181C19.7999 18.876 19.1894 19.5873 18.7712 20.398C18.3529 21.2088 18.1378 22.0977 18.1422 22.9975C18.1444 23.8865 18.3583 24.7639 18.7685 25.5663C19.1786 26.3687 19.7746 27.076 20.5135 27.637C20.2135 27.6637 19.8993 27.6637 19.5707 27.6637H10.9996C3.85703 27.6637 1 24.9973 1 18.3314V10.3323C1 3.66637 3.85703 1 10.9996 1H19.5707C26.7133 1 29.5703 3.66637 29.5703 10.3323Z"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.0012 23.0008C30.9992 23.8547 30.802 24.6985 30.4226 25.4756C30.0432 26.2527 29.4905 26.9452 28.8012 27.507C27.6727 28.4402 26.2014 29.0001 24.5728 29.0001C23.0443 29.0001 21.6301 28.4935 20.5302 27.6403H20.5159C19.777 27.0792 19.1809 26.3719 18.7708 25.5696C18.3607 24.7672 18.1468 23.8898 18.1445 23.0008C18.1445 21.1077 19.0731 19.4145 20.5587 18.3213C21.6957 17.4659 23.1125 17.0001 24.5728 17.0015C26.5871 17.0015 28.3727 17.8547 29.5441 19.2012C30.4583 20.2278 31.0012 21.561 31.0012 23.0008Z"
        stroke="#969BA0"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.0703 22.9964L23.656 24.4763L27.0844 21.5166"
        stroke="#969BA0"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AppointmentsIcon;
